import { render } from "./FileMoveDialog.vue?vue&type=template&id=ddc24548"
import script from "./FileMoveDialog.vue?vue&type=script&lang=js"
export * from "./FileMoveDialog.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/7c12f39a-5a06-429e-8ff2-90249d9b2982/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__